"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateDisplayDto = exports.AvailabilityRangeDto = exports.AdPoliciesDto = exports.DisplayPricingDto = exports.PricingMultiplierDto = exports.PricingModelsDto = exports.PricingModelFixedSlotsDto = exports.FixedSlotOptionDto = exports.PricingModelSovDto = exports.PricingModelCpsDto = exports.PricingModelCpmDto = exports.PriceModelBaseDto = exports.AudienceStatInputDto = exports.AudienceStatHourDto = exports.DisplayAddressDetailsDto = exports.MediaItemDto = exports.normalizeNestedClassArrayInput = exports.normalizeNestedClassInput = exports.normalizeNestedObjectInput = exports.normalizeNestedObjectArrayInput = exports.normalizeStringArrayInput = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const types_1 = require("../../../types");
const approximate_daily_impressions_1 = require("./commons/approximate-daily-impressions");
const display_opacity_schedule_1 = require("./commons/display-opacity-schedule");
const display_schedule_1 = require("./commons/display-schedule");
const display_widget_1 = require("./commons/display-widget");
const isBlankString = (value) => typeof value === "string" && value.trim() === "";
const isPlainObject = (value) => typeof value === "object" && value !== null && !Array.isArray(value);
const getIndexedObjectValues = (value) => {
    if (!isPlainObject(value)) {
        return undefined;
    }
    const entries = Object.entries(value).filter(([key, entryValue]) => {
        if (!/^\d+$/.test(key)) {
            return false;
        }
        return entryValue !== undefined && entryValue !== null && !isBlankString(entryValue);
    });
    if (entries.length === 0) {
        return undefined;
    }
    return entries
        .sort(([left], [right]) => Number(left) - Number(right))
        .map(([, entryValue]) => entryValue);
};
const tryParseJsonValue = (value) => {
    try {
        return JSON.parse(value);
    }
    catch {
        return value;
    }
};
const normalizeStringArrayInput = (value) => {
    if (value === undefined || value === null || isBlankString(value)) {
        return [];
    }
    const indexedValues = getIndexedObjectValues(value);
    const values = typeof value === "string"
        ? value.split(",")
        : Array.isArray(value)
            ? value
            : (indexedValues ?? [value]);
    return values
        .map((item) => (typeof item === "string" ? item.trim() : item))
        .filter((item) => typeof item === "string" && item !== "");
};
exports.normalizeStringArrayInput = normalizeStringArrayInput;
const normalizeNestedObjectArrayInput = (value, wrapSingleObject = false) => {
    if (value === undefined || value === null || value === "" || isBlankString(value)) {
        return undefined;
    }
    const normalizedValue = typeof value === "string" ? tryParseJsonValue(value) : value;
    const indexedValues = getIndexedObjectValues(normalizedValue);
    if (indexedValues) {
        return indexedValues
            .filter((item) => item !== undefined && item !== null && !isBlankString(item))
            .map((item) => {
            if (typeof item !== "string") {
                return item;
            }
            const trimmedItem = item.trim();
            if ((trimmedItem.startsWith("{") && trimmedItem.endsWith("}")) ||
                (trimmedItem.startsWith("[") && trimmedItem.endsWith("]"))) {
                return tryParseJsonValue(trimmedItem);
            }
            return item;
        });
    }
    if (Array.isArray(normalizedValue)) {
        return normalizedValue
            .filter((item) => item !== undefined && item !== null && !isBlankString(item))
            .map((item) => {
            if (typeof item !== "string") {
                return item;
            }
            const trimmedItem = item.trim();
            if ((trimmedItem.startsWith("{") && trimmedItem.endsWith("}")) ||
                (trimmedItem.startsWith("[") && trimmedItem.endsWith("]"))) {
                return tryParseJsonValue(trimmedItem);
            }
            return item;
        });
    }
    if (wrapSingleObject && typeof normalizedValue === "object" && normalizedValue !== null) {
        return [normalizedValue];
    }
    return undefined;
};
exports.normalizeNestedObjectArrayInput = normalizeNestedObjectArrayInput;
const normalizeNestedObjectInput = (value) => {
    if (value === undefined || value === null || value === "" || isBlankString(value)) {
        return undefined;
    }
    const normalizedValue = typeof value === "string" ? tryParseJsonValue(value) : value;
    return isPlainObject(normalizedValue) ? normalizedValue : value;
};
exports.normalizeNestedObjectInput = normalizeNestedObjectInput;
const normalizeNestedClassInput = (value, target) => {
    const normalizedValue = (0, exports.normalizeNestedObjectInput)(value);
    return isPlainObject(normalizedValue)
        ? (0, class_transformer_1.plainToInstance)(target, normalizedValue)
        : normalizedValue;
};
exports.normalizeNestedClassInput = normalizeNestedClassInput;
const normalizeNestedClassArrayInput = (value, target) => {
    const normalizedValue = (0, exports.normalizeNestedObjectArrayInput)(value);
    return Array.isArray(normalizedValue)
        ? normalizedValue.map((item) => (isPlainObject(item) ? (0, class_transformer_1.plainToInstance)(target, item) : item))
        : normalizedValue;
};
exports.normalizeNestedClassArrayInput = normalizeNestedClassArrayInput;
class MediaItemDto {
    url;
    type;
}
exports.MediaItemDto = MediaItemDto;
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], MediaItemDto.prototype, "url", void 0);
__decorate([
    (0, class_validator_1.IsIn)(["image", "video"], { message: 'El tipo debe ser "image" o "video"' }),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], MediaItemDto.prototype, "type", void 0);
class DisplayAddressDetailsDto {
    address_line_1;
    address_line_2;
    postal_code;
    city;
    state_region;
    country;
}
exports.DisplayAddressDetailsDto = DisplayAddressDetailsDto;
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DisplayAddressDetailsDto.prototype, "address_line_1", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DisplayAddressDetailsDto.prototype, "address_line_2", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DisplayAddressDetailsDto.prototype, "postal_code", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DisplayAddressDetailsDto.prototype, "city", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DisplayAddressDetailsDto.prototype, "state_region", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DisplayAddressDetailsDto.prototype, "country", void 0);
class AudienceStatHourDto {
    start;
    end;
    count;
}
exports.AudienceStatHourDto = AudienceStatHourDto;
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], AudienceStatHourDto.prototype, "start", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], AudienceStatHourDto.prototype, "end", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], AudienceStatHourDto.prototype, "count", void 0);
class AudienceStatInputDto {
    day_of_week;
    daily_total;
    hours = [];
}
exports.AudienceStatInputDto = AudienceStatInputDto;
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(7),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], AudienceStatInputDto.prototype, "day_of_week", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], AudienceStatInputDto.prototype, "daily_total", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, exports.normalizeNestedObjectArrayInput)(value)),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => AudienceStatHourDto),
    __metadata("design:type", Array)
], AudienceStatInputDto.prototype, "hours", void 0);
// --- 1. DTOs para Modelos de Precio (CPM, CPS, SOV, Slots) ---
class PriceModelBaseDto {
    enabled;
    base_rate;
}
exports.PriceModelBaseDto = PriceModelBaseDto;
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], PriceModelBaseDto.prototype, "enabled", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], PriceModelBaseDto.prototype, "base_rate", void 0);
class PricingModelCpmDto extends PriceModelBaseDto {
    min_impressions;
}
exports.PricingModelCpmDto = PricingModelCpmDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1),
    (0, class_validator_1.ValidateIf)((o) => o.min_impressions !== undefined),
    (0, class_transformer_1.Transform)(({ value }) => value !== undefined && value !== null && value !== "" ? Number(value) : undefined),
    __metadata("design:type", Number)
], PricingModelCpmDto.prototype, "min_impressions", void 0);
class PricingModelCpsDto extends PriceModelBaseDto {
    min_duration_seconds;
}
exports.PricingModelCpsDto = PricingModelCpsDto;
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], PricingModelCpsDto.prototype, "min_duration_seconds", void 0);
class PricingModelSovDto {
    enabled;
    base_rate_percentage; // Precio por 1%
    min_percentage;
}
exports.PricingModelSovDto = PricingModelSovDto;
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], PricingModelSovDto.prototype, "enabled", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(100),
    (0, class_transformer_1.Transform)(({ value }) => (value !== undefined ? Number(value) : undefined)),
    __metadata("design:type", Number)
], PricingModelSovDto.prototype, "base_rate_percentage", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(100),
    (0, class_transformer_1.Transform)(({ value }) => (value !== undefined ? Number(value) : undefined)),
    __metadata("design:type", Number)
], PricingModelSovDto.prototype, "min_percentage", void 0);
class FixedSlotOptionDto {
    name;
    duration_seconds;
    price;
}
exports.FixedSlotOptionDto = FixedSlotOptionDto;
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], FixedSlotOptionDto.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], FixedSlotOptionDto.prototype, "duration_seconds", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], FixedSlotOptionDto.prototype, "price", void 0);
class PricingModelFixedSlotsDto {
    enabled;
    options;
}
exports.PricingModelFixedSlotsDto = PricingModelFixedSlotsDto;
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], PricingModelFixedSlotsDto.prototype, "enabled", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => FixedSlotOptionDto),
    __metadata("design:type", Array)
], PricingModelFixedSlotsDto.prototype, "options", void 0);
class PricingModelsDto {
    cpm;
    cps;
    sov;
    fixed_slots;
}
exports.PricingModelsDto = PricingModelsDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PricingModelCpmDto),
    __metadata("design:type", PricingModelCpmDto)
], PricingModelsDto.prototype, "cpm", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PricingModelCpsDto),
    __metadata("design:type", PricingModelCpsDto)
], PricingModelsDto.prototype, "cps", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PricingModelSovDto),
    __metadata("design:type", PricingModelSovDto)
], PricingModelsDto.prototype, "sov", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PricingModelFixedSlotsDto),
    __metadata("design:type", PricingModelFixedSlotsDto)
], PricingModelsDto.prototype, "fixed_slots", void 0);
// --- 2. DTO para Multiplicadores (Day Parting / Eventos) ---
class PricingMultiplierDto {
    _id; // Para editar uno existente
    name;
    start_time;
    end_time;
    days_of_week;
    multiplier;
    // Nuevos campos (Fechas y Prioridad)
    priority;
    valid_from;
    valid_to;
}
exports.PricingMultiplierDto = PricingMultiplierDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PricingMultiplierDto.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PricingMultiplierDto.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(86400) // Segundos máx en un día
    ,
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], PricingMultiplierDto.prototype, "start_time", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(86400),
    (0, class_transformer_1.Transform)(({ value, obj }) => {
        const startTime = obj.start_time;
        const endTime = Number(value);
        // Asegura que end_time sea mayor que start_time
        if (endTime <= startTime) {
            return startTime + 1; // Mínimo 1 segundo después de start_time
        }
        return endTime;
    }),
    __metadata("design:type", Number)
], PricingMultiplierDto.prototype, "end_time", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsInt)({ each: true }),
    (0, class_validator_1.Min)(0, { each: true }),
    (0, class_validator_1.Max)(6, { each: true }) // 0=Dom, 6=Sab
    ,
    (0, class_transformer_1.Transform)(({ value }) => {
        if (typeof value === "string") {
            return value
                .split(",")
                .map((v) => parseInt(v, 10))
                .filter((v) => !isNaN(v) && v >= 0 && v <= 6);
        }
        if (Array.isArray(value)) {
            return value.map((v) => Number(v)).filter((v) => !isNaN(v) && v >= 0 && v <= 6);
        }
        return [];
    }),
    __metadata("design:type", Array)
], PricingMultiplierDto.prototype, "days_of_week", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], PricingMultiplierDto.prototype, "multiplier", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(100),
    (0, class_transformer_1.Transform)(({ value }) => (value !== undefined ? Number(value) : undefined)),
    (0, class_validator_1.ValidateIf)((o) => o.priority !== undefined),
    __metadata("design:type", Number)
], PricingMultiplierDto.prototype, "priority", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => (value ? new Date(value) : undefined)),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Date)
], PricingMultiplierDto.prototype, "valid_from", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => (value ? new Date(value) : undefined)),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Date)
], PricingMultiplierDto.prototype, "valid_to", void 0);
// --- 3. DTO Wrapper Principal de Precios ---
class DisplayPricingDto {
    currency;
    tax_percentage;
    models;
    time_multipliers;
}
exports.DisplayPricingDto = DisplayPricingDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)(({ value }) => value.toUpperCase()),
    __metadata("design:type", String)
], DisplayPricingDto.prototype, "currency", void 0);
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => value === undefined || value === null || value === "" ? undefined : Number(value)),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], DisplayPricingDto.prototype, "tax_percentage", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => {
        if (value === undefined || value === null || value === "")
            return undefined;
        if (typeof value === "string") {
            try {
                return JSON.parse(value);
            }
            catch {
                return undefined;
            }
        }
        return value;
    }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PricingModelsDto),
    (0, class_validator_1.ValidateIf)((o) => !!o.models),
    __metadata("design:type", PricingModelsDto)
], DisplayPricingDto.prototype, "models", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => {
        const normalizedValue = (0, exports.normalizeNestedObjectArrayInput)(value);
        return Array.isArray(normalizedValue) ? normalizedValue : undefined;
    }),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => PricingMultiplierDto),
    (0, class_validator_1.ValidateIf)((o) => Array.isArray(o.time_multipliers) && o.time_multipliers.length > 0),
    __metadata("design:type", Array)
], DisplayPricingDto.prototype, "time_multipliers", void 0);
class AdPoliciesDto {
    min_duration_sec;
    max_duration_sec;
    max_loop_duration_seconds;
    /**
     * @deprecated Owner-campaign slot capacity is controlled by top-level ownerCampaignSlots* entitlement fields.
     */
    max_own_campaign_loop_duration_seconds;
}
exports.AdPoliciesDto = AdPoliciesDto;
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => (value !== undefined ? Number(value) : undefined)),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(10),
    (0, class_validator_1.Max)(3600),
    (0, class_validator_1.ValidateIf)((o) => o.min_duration_sec !== undefined),
    __metadata("design:type", Number)
], AdPoliciesDto.prototype, "min_duration_sec", void 0);
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => (value !== undefined ? Number(value) : undefined)),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(10),
    (0, class_validator_1.Max)(3600),
    (0, class_validator_1.ValidateIf)((o) => o.max_duration_sec !== undefined),
    __metadata("design:type", Number)
], AdPoliciesDto.prototype, "max_duration_sec", void 0);
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => value !== undefined && value !== null && value !== "" ? Number(value) : undefined),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.ValidateIf)((o) => o.max_loop_duration_seconds !== undefined),
    __metadata("design:type", Number)
], AdPoliciesDto.prototype, "max_loop_duration_seconds", void 0);
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => value !== undefined && value !== null && value !== "" ? Number(value) : undefined),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.ValidateIf)((o) => o.max_own_campaign_loop_duration_seconds !== undefined)
    /**
     * @deprecated Owner-campaign slot capacity is controlled by top-level ownerCampaignSlots* entitlement fields.
     */
    ,
    __metadata("design:type", Number)
], AdPoliciesDto.prototype, "max_own_campaign_loop_duration_seconds", void 0);
class AvailabilityRangeDto {
    start;
    end;
}
exports.AvailabilityRangeDto = AvailabilityRangeDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => (value ? new Date(value) : null)),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], AvailabilityRangeDto.prototype, "start", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => (value ? new Date(value) : null)),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], AvailabilityRangeDto.prototype, "end", void 0);
class CreateDisplayDto {
    display_id;
    name;
    owner;
    audio;
    autoaccept_media;
    category;
    description;
    display_tech_info;
    ad_policies;
    external;
    interior;
    restricted_access;
    restricted_send;
    tags;
    exclusions;
    token;
    url_streetview;
    address;
    address_details;
    profile_picture;
    widget;
    availability_range;
    schedule;
    opacity_schedule;
    display_time_zone;
    provider;
    pricing;
    standard_price;
    metadata;
    screensaver_url;
    platform_provider;
    standard_currency;
    /** @deprecated Use audience_stats daily totals. */
    approximateDailyImpressions;
    audience_stats;
    private_only;
    send_restriction; // Restriction on sending content (e.g., 'only-list', etc.)
    media_types;
    internal_blacklist;
    show_qr_to_send_content;
    show_display_qr;
    show_media_qr;
    medias;
    published;
    files;
    visible;
}
exports.CreateDisplayDto = CreateDisplayDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], CreateDisplayDto.prototype, "display_id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateDisplayDto.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateDisplayDto.prototype, "owner", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], CreateDisplayDto.prototype, "audio", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], CreateDisplayDto.prototype, "autoaccept_media", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateDisplayDto.prototype, "category", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateDisplayDto.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateDisplayDto.prototype, "display_tech_info", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => AdPoliciesDto),
    __metadata("design:type", AdPoliciesDto)
], CreateDisplayDto.prototype, "ad_policies", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], CreateDisplayDto.prototype, "external", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], CreateDisplayDto.prototype, "interior", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], CreateDisplayDto.prototype, "restricted_access", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], CreateDisplayDto.prototype, "restricted_send", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, exports.normalizeStringArrayInput)(value)),
    __metadata("design:type", Array)
], CreateDisplayDto.prototype, "tags", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsIn)(types_1.DISPLAY_EXCLUSIONS, { each: true }),
    (0, class_transformer_1.Transform)(({ value }) => (0, exports.normalizeStringArrayInput)(value)),
    __metadata("design:type", Array)
], CreateDisplayDto.prototype, "exclusions", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateDisplayDto.prototype, "token", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateDisplayDto.prototype, "url_streetview", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateDisplayDto.prototype, "address", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, exports.normalizeNestedClassInput)(value, DisplayAddressDetailsDto)),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DisplayAddressDetailsDto),
    __metadata("design:type", DisplayAddressDetailsDto)
], CreateDisplayDto.prototype, "address_details", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateDisplayDto.prototype, "profile_picture", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => display_widget_1.Widget),
    __metadata("design:type", display_widget_1.Widget)
], CreateDisplayDto.prototype, "widget", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => AvailabilityRangeDto),
    __metadata("design:type", AvailabilityRangeDto)
], CreateDisplayDto.prototype, "availability_range", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Transform)(({ value }) => typeof value === "object" ? value : typeof value === "string" ? JSON.parse(value) : {}),
    (0, class_transformer_1.Type)(() => display_schedule_1.DisplayScheduleDto),
    __metadata("design:type", display_schedule_1.DisplayScheduleDto)
], CreateDisplayDto.prototype, "schedule", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Transform)(({ value }) => typeof value === "object" ? value : typeof value === "string" ? JSON.parse(value) : {}),
    (0, class_transformer_1.Type)(() => display_opacity_schedule_1.DisplayOpacityScheduleDto),
    __metadata("design:type", display_opacity_schedule_1.DisplayOpacityScheduleDto)
], CreateDisplayDto.prototype, "opacity_schedule", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateDisplayDto.prototype, "display_time_zone", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)(({ value }) => (!value ? undefined : value)),
    __metadata("design:type", String)
], CreateDisplayDto.prototype, "provider", void 0);
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => {
        if (value === undefined)
            return undefined;
        if (!value)
            return null;
        if (typeof value === "string") {
            try {
                return JSON.parse(value);
            }
            catch {
                return value; // Deja que el validador falle si no es JSON válido
            }
        }
        return value;
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateIf)((o) => !!o.pricing),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DisplayPricingDto),
    __metadata("design:type", Object)
], CreateDisplayDto.prototype, "pricing", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], CreateDisplayDto.prototype, "standard_price", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, exports.normalizeNestedObjectInput)(value)),
    __metadata("design:type", Function)
], CreateDisplayDto.prototype, "metadata", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateDisplayDto.prototype, "screensaver_url", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateDisplayDto.prototype, "platform_provider", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateDisplayDto.prototype, "standard_currency", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => approximate_daily_impressions_1.ApproximateDailyImpressions)
    /** @deprecated Use audience_stats daily totals. */
    ,
    __metadata("design:type", approximate_daily_impressions_1.ApproximateDailyImpressions)
], CreateDisplayDto.prototype, "approximateDailyImpressions", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, exports.normalizeNestedClassArrayInput)(value, AudienceStatInputDto)),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => AudienceStatInputDto),
    (0, class_validator_1.ValidateIf)((o) => !!o?.audience_stats?.length),
    __metadata("design:type", Array)
], CreateDisplayDto.prototype, "audience_stats", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], CreateDisplayDto.prototype, "private_only", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)(({ value }) => (!value ? undefined : value)),
    (0, class_validator_1.ValidateIf)((o) => !!o.send_restriction),
    (0, class_validator_1.IsIn)(["only-list", "none"], {
        message: "send_restriction must be one of: only-list, none",
    }),
    __metadata("design:type", String)
], CreateDisplayDto.prototype, "send_restriction", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, exports.normalizeStringArrayInput)(value)),
    __metadata("design:type", Array)
], CreateDisplayDto.prototype, "media_types", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_transformer_1.Transform)(({ value }) => (0, exports.normalizeStringArrayInput)(value)),
    __metadata("design:type", Array)
], CreateDisplayDto.prototype, "internal_blacklist", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], CreateDisplayDto.prototype, "show_qr_to_send_content", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], CreateDisplayDto.prototype, "show_display_qr", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], CreateDisplayDto.prototype, "show_media_qr", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, exports.normalizeNestedObjectArrayInput)(value, true)),
    (0, class_validator_1.IsArray)({ message: "Medias debe ser un array" }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => MediaItemDto),
    (0, class_validator_1.ValidateIf)((o) => !!o?.medias?.length),
    __metadata("design:type", Array)
], CreateDisplayDto.prototype, "medias", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], CreateDisplayDto.prototype, "published", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], CreateDisplayDto.prototype, "files", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], CreateDisplayDto.prototype, "visible", void 0);
